<template>
    <div class="container mt-50">
        <div class="titre" id="differentes_etapes">
            <h2 class="text-uppercase">
                <span class="span-background">
                    Les étapes de votre formation
                </span>
            </h2>
        </div>
        <div class="d-flex flex-column gap-3 steps">
            <div class="d-flex justify-content-between stepItem">
                <div class="position-relative">
                    <div class="vr position-absolute"></div>
                    <div class="position-relative">
                        <nuxt-img src="/images/icon/Ellipse 6.png"></nuxt-img>
                        <div class="stepNumber">1.</div>
                    </div>
                </div>
                <div class="bodyStep">
                    <h3 class="text-start">Avant la formation</h3>
                    <div class="textBodyStep text-start" :class="{ collapsed: isCollapsed1 }">
                        <p class="mb-3">Vous recevrez une convocation 2-3 semaines avant le début de la formation, vous
                            confirmant :
                        </p>
                        <div class="mb-3 text-start">
                            <ul class="listResponsabilite ul-position">
                                <li>l’intitulé de votre formation ainsi que la date</li>
                                <li>le lieu de votre formation, si celle-ci est en présentiel.</li>
                                <li>le lien d’accès à classe virtuelle, pour les formations en distanciel. Nous
                                    utilisons
                                    majoritairement Zoom, et nous vous inviterons à tester votre matériel (caméra,
                                    micro)
                                    avant le début de la session de formation.</li>
                            </ul>
                        </div>
                        <p class="mb-3">Pour toutes question ou problème, vous pouvez contacter le Pôle Formation par
                            téléphone au 07 88 85 31 32 (pour plus de réactivité) ou via notre mail :
                            <a href="mailto:poleformation@emciconseil.fr Nos centres">poleformation@emciconseil.fr</a>
                        </p>
                    </div>
                </div>
                <div class="btn-plus-moins">
                    <nuxt-img src="/images/icon/circle-plus.png" :class="{ expanded: isExpanded1 }"
                        @click="collapsedTextBodySteps(1)"></nuxt-img>
                    <nuxt-img src="/images/icon/circle-minus.png" class="minus" :class="{ collapsed: isCollapsed1 }"
                        @click="collapsedTextBodySteps(1)"></nuxt-img>
                </div>
            </div>
            <div class="d-flex justify-content-between stepItem">
                <div class="position-relative">
                    <div class="vr position-absolute"></div>
                    <div class="position-relative">
                        <nuxt-img src="/images/icon/Ellipse 6.png"></nuxt-img>
                        <div class="stepNumber">2.</div>
                    </div>
                </div>
                <div class="bodyStep">
                    <h3 class="text-start">Pendant la formation</h3>
                    <div class="textBodyStep" :class="{ collapsed: isCollapsed2 }">
                        <p class="mb-3 text-start">
                            <b>Le déroulement</b> de votre journée de formation sera communiqué par votre
                            formateur : les pauses, le déjeuner, …
                        </p>
                        <p class="mb-3 text-start">
                            <b>Les outils pédagogiques</b> utilisés par votre formateur seront mis à votre disposition
                            sur
                            la plateforme digitale Digiforma. Vous y retrouverez également les différents questionnaires
                            à
                            compléter, avant et après votre formation.
                        </p>
                    </div>
                </div>
                <div class="btn-plus-moins">
                    <nuxt-img src="/images/icon/circle-plus.png" :class="{ expanded: isExpanded2 }"
                        @click="collapsedTextBodySteps(2)"></nuxt-img>
                    <nuxt-img src="/images/icon/circle-minus.png" class="minus" :class="{ collapsed: isCollapsed2 }"
                        @click="collapsedTextBodySteps(2)"></nuxt-img>
                </div>
            </div>
            <div class="d-flex justify-content-between stepItem">
                <div class="position-relative">
                    <div class="vr position-absolute"></div>
                    <div class="position-relative">
                        <nuxt-img src="/images/icon/Ellipse 6.png"></nuxt-img>
                        <div class="stepNumber">3.</div>
                    </div>
                </div>
                <div class="bodyStep">
                    <h3 class="text-start">Après la formation </h3>
                    <div class="textBodyStep" :class="{ collapsed: isCollapsed3 }">
                        <p class="text-start">
                            <b>Une attestation de fin de formation</b> vous sera envoyée par mail à la fin de votre
                            session
                            de formation.
                        </p>
                    </div>
                </div>
                <div class="btn-plus-moins">
                    <nuxt-img src="/images/icon/circle-plus.png" :class="{ expanded: isExpanded3 }"
                        @click="collapsedTextBodySteps(3)"></nuxt-img>
                    <nuxt-img src="/images/icon/circle-minus.png" class="minus" :class="{ collapsed: isCollapsed3 }"
                        @click="collapsedTextBodySteps(3)"></nuxt-img>
                </div>
            </div>
        </div>
    </div>
</template>
<script setup>
const isCollapsed1 = ref(false)
const isCollapsed2 = ref(false)
const isCollapsed3 = ref(false)

const isExpanded1 = ref(false)
const isExpanded2 = ref(false)
const isExpanded3 = ref(false)

const collapsedTextBodySteps = (number) => {
    switch (number) {
        case 1:
            isCollapsed1.value = !isCollapsed1.value
            isExpanded1.value = !isExpanded1.value
            break
        case 2:
            isCollapsed2.value = !isCollapsed2.value
            isExpanded2.value = !isExpanded2.value
            break
        case 3:
            isCollapsed3.value = !isCollapsed3.value
            isExpanded3.value = !isExpanded3.value
            break
    }

}
</script>
<style scoped>
.ul-position {
    padding: 20px 50px;
    gap: 1rem;
    color: var(--accent, #25233E);

    /* txt */
    font-family: Inter;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 144%;
    letter-spacing: 0.72px;
}


.ul-position-financement {
    color: var(--accent, #25233E);

    /* txt */
    font-family: Inter;
    font-size: 21px;
    font-style: normal;
    font-weight: 400;
    line-height: 144%;
    letter-spacing: 0.72px;
    padding: 20px 350px;
}

.titre {
    border-radius: 30px;
    border: 3px solid var(--secondaire, #FAB74B);
    padding: 60px 50px;
}

h2 {
    font-family: Nunito;
    font-size: 50px;
    font-style: normal;
    font-weight: 600;
    line-height: 111.5%;
    /* 61.325px */
    letter-spacing: -0.825px;
    text-transform: uppercase;
    text-align: center;
}

.textTitre {
    font-family: Inter;
    font-size: 18px;
    font-style: normal;
    font-weight: 400;
    line-height: 144%;
    /* 25.92px */
    letter-spacing: 0.72px;
    text-align: center;
}

.textTitre p:nth-child(1),
.textTitre p:nth-child(4) {
    /* h3 */
    font-family: Nunito;
    font-size: 34px;
    font-weight: 500;
    line-height: 111.5%;
    /* 37.91px */
    letter-spacing: -0.51px;
}

.textTitre p:nth-child(2) a {
    color: #318EC7;
    font-size: 21px;
    font-style: normal;
    font-weight: 600;
    line-height: 133%;
    /* 27.93px */
    letter-spacing: 0.84px;
    text-decoration-line: underline;
}

.textTitre p:nth-child(3) {
    font-weight: 600;
    line-height: 144%;
    /* 25.92px */
    letter-spacing: 0.72px;
    padding-left: 14rem;
    padding-right: 14rem;
}

.steps {
    margin: 0 5rem 0 5rem;
    overflow: hidden;
}

.stepItem {
    min-height: 120px;
    align-items: center;
}

.vr {
    background-color: #fab74b;
    left: 44%;
    min-height: 46em;
    opacity: 1;
    top: -449%;
    width: 8px;
}

.stepNumber {
    font-family: Nunito;
    font-size: 34px;
    font-style: normal;
    font-weight: 500;
    line-height: 111.5%;
    /* 37.91px */
    letter-spacing: -0.51px;
    position: absolute;
    top: 27%;
    left: 35%;
    z-index: 2;
}

.bodyStep {
    width: 80%;
}

p {
    font-size: 18px;
}

ul {
    list-style-type: disc;
    padding-left: 2rem;
}

.textBodyStep,
.minus,
.expanded {
    display: none;
}

.collapsed {
    display: block;
}

.contact {
    column-gap: 1rem;
}

.fa-circle-info {
    font-size: 48px;
    color: #318EC7;
}

@media only screen and (min-width: 300px) and (max-width: 374px) {
    h3 {
        font-size: 20px !important;
    }

    .textTitre p {
        padding-left: 0px !important;
        padding-right: 0px !important;
    }

    .textTitre p:nth-child(2) a {
        font-size: 9px !important;
    }

    button-group a {
        width: 20% !important;
    }

    .contact {
        width: 100% !important;
    }

    .vr {
        top: -1276%;
        left: 47%;
        min-height: 56em;
    }


    .bodyStep h3 {
        margin-top: 0px;
        margin-left: 20px;
    }

    .stepNumber {
        font-size: 16px;
        top: 40%;
        left: 40%;
        z-index: 2;
    }

    .position-relative img {
        max-width: 50px !important;
    }

    .btn-plus-moins img {
        max-width: 20px !important;
    }

    .steps {
        margin: 0 0rem 0 0rem;
    }

    .bodyStep {
        width: 60%;
    }

    .ul-position {
        padding: 5px 5px;
        font-size: 14px;
        margin-left: 20px;
    }

    .ul-position-financement {
        font-size: 14px;
        padding: 20px 60px;
    }

    p {
        margin-bottom: 1rem;
        margin-top: 1rem;
        margin-left: 20px;
        line-height: 144%;
    }

    .titre {
        padding: 30px 10px;
    }
}

@media only screen and (min-width: 375px) and (max-width: 426px) {
    h3 {
        font-size: 20px !important;
    }

    .textTitre p {
        padding-left: 0px !important;
        padding-right: 0px !important;
    }

    .textTitre p:nth-child(2) a {
        font-size: 9px !important;
    }

    button-group a {
        width: 20% !important;
    }

    .contact {
        width: 100% !important;
    }

    .vr {
        left: 44%;
        min-height: 43em;
        opacity: 1;
        top: -735%;
        width: 8px;
    }

    .bodyStep h3 {
        margin-top: 10px;
        margin-left: 20px;
    }

    .stepNumber {
        font-size: 16px;
        top: 38%;
        z-index: 2;
        left: 38%;
    }

    .position-relative img {
        max-width: 50px !important;
    }

    .btn-plus-moins img {
        max-width: 20px !important;
    }

    .steps {
        margin: 0 0rem 0 0rem;
    }

    .bodyStep {
        width: 65%;
    }

    .position-relative img {
        max-width: 80%;
    }

    .ul-position {
        padding: 10px 10px;
        font-size: 14px;
        margin-left: 16px;
    }

    .ul-position-financement {
        font-size: 14px;
        padding: 20px 60px;
    }

    p {
        margin-bottom: 1rem;
        margin-top: 1rem;
        margin-left: 20px;
        line-height: 144%;
    }
}

@media only screen and (min-width: 501px) and (max-width: 768px) {
    h3 {
        font-size: 20px !important;
    }

    .ul-position {
        padding: 10px 10px;
        gap: 1rem;
        font-size: 14px;
    }

    .ul-position-financement {
        font-size: 14px;
        padding: 20px 160px;
    }

    .stepNumber {
        font-size: 25px;
        top: 34%;
        left: 37%;
    }
}


/* Pour les appareils entre 768px et 991px de large (tablettes en mode paysage) */
@media only screen and (min-width: 769px) and (max-width: 991px) {}

/* Pour les appareils entre 992px et 1199px de large (tablettes en mode portrait et ordinateurs portables) */
@media only screen and (min-width: 992px) and (max-width: 1199px) {
    .container {
        max-width: 950px !important;
    }

    p {
        font-size: 18px !important;
    }

    ul li {
        font-size: 17px !important;
    }

    .ul-position-financement {
        font-size: 14px;
        padding: 20px 260px;
    }


}

@media only screen and (min-width: 938px) and (max-width: 1275px) {}

/* Pour les appareils de 1200px de large et plus (ordinateurs de bureau) */
@media only screen and (min-width: 1200px) {}
</style>